module.exports = __webpack_public_path__ + "img/ejemplo-de-anuncio-restaurante.24f6a27e.jpg";